import React from 'react';
import { DatePicker } from 'rsuite';
import { edit_sample_collector_schedule } from '../utilis/sampleCollectorServices';
import moment from 'moment';
// import { useSelector } from 'react-redux';
// import { get_selected_plant_name } from '../../../redux/auth/auth.selectors';

export const CustomCollectorDatePicker = (params) => {
    // const { selected_plant } = useSelector(get_selected_plant_name);
    // Check if value is truthy and represents a valid date
    const { value, row, id, field, api, ...otherProps } = params;
    // console.log(row);
    // console.log({ value });
    const handleDatePickerChange = async (newValue) => {
        const material_type = (() => {
            switch (row.sample_type) {
                case "SFG(without micro)":
                    return "INTM";
                case "SFG(with micro)":
                    return "INTM";
                case "FP(without micro)":
                    return "FP";
                case "FP(with micro)":
                    return "FP";
                case "CB(urgent)":
                    return "CB";
                case "CB(additional)":
                    return "CB";
                case "CB":
                    return "CB";
                default:
                    return row.sample_type;
            }
        })();
        const expected_delivery_date_by_ip_qa = moment(newValue).format("YYYY-MM-DD HH:mm");
        const updatedRow = {
            ...row,
            expected_delivery_date_by_ip_qa,
        };
        const result = await edit_sample_collector_schedule(
            updatedRow,
            material_type
        );
        if (result) {
            api.updateRows([{
                id,
                expected_delivery_date_by_ip_qa
            }]);
        }
    };
    return (
        <div style={{
            minWidth: "200px",
            width: "100%",
        }}>
            <DatePicker
                style={{
                    width: "100%"
                }}
                format="yyyy-MM-dd HH:mm"
                placement={"auto"}
                // disabled={(selected_plant === "sunpharma_dewas_sterile_API" && row?.["storage_condition"] === "") ? true : false}
                value={(value && (typeof value === "string" && value?.length > 0 && new Date(value))) || null}
                cleanable={false}
                placeholder={"YYYY-MM-DD hh:mm"}
                onChange={handleDatePickerChange}
                {...otherProps}

            />
        </div>
    );
};
